module.exports = __webpack_public_path__ + "static/tesla-solar-roof-1-540w-1c2bd9ca696a553f8db48af36b2d8ba7.jpg";